import { render, staticRenderFns } from "./DialogWelcomeText.vue?vue&type=template&id=51be29f3&scoped=true"
import script from "./DialogWelcomeText.vue?vue&type=script&lang=js"
export * from "./DialogWelcomeText.vue?vue&type=script&lang=js"
import style0 from "./DialogWelcomeText.vue?vue&type=style&index=0&id=51be29f3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be29f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51be29f3')) {
      api.createRecord('51be29f3', component.options)
    } else {
      api.reload('51be29f3', component.options)
    }
    module.hot.accept("./DialogWelcomeText.vue?vue&type=template&id=51be29f3&scoped=true", function () {
      api.rerender('51be29f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/dialogs/dialog_welcome_text/DialogWelcomeText.vue"
export default component.exports